export default __webpack_public_path__ + "static/media/banner.f264b1dd.svg";